import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { timeout, catchError, mergeMap, retryWhen } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class HttpTimeoutRetryInterceptor implements HttpInterceptor {
  private readonly DEFAULT_TIMEOUT_MS = 30000; // 30 segundos
  private readonly LONG_TIMEOUT_MS = 90000; // 90 segundos para endpoints pesados
  private readonly MAX_RETRIES = 2;
  private _isRedirecting = false;

  // Endpoints que precisam de timeout maior (backend lento)
  private readonly LONG_TIMEOUT_PATTERNS = [
    '/Client/graph',
  ];

  // Endpoints que NAO devem fazer retry (erro 500 nao e transitorio)
  private readonly NO_RETRY_PATTERNS = [
    '/Insight/report',
  ];

  constructor(private injector: Injector) {}

  private getTimeout(url: string): number {
    if (this.LONG_TIMEOUT_PATTERNS.some(p => url.includes(p))) {
      return this.LONG_TIMEOUT_MS;
    }
    return this.DEFAULT_TIMEOUT_MS;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutMs = this.getTimeout(req.url);

    return next.handle(req).pipe(
      timeout(timeoutMs),
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error: HttpErrorResponse, index: number) => {
            if (index >= this.MAX_RETRIES) {
              return throwError(() => error);
            }
            // Retry em erros de servidor, rede ou timeout — NÃO retry em 401
            const skipRetry = this.NO_RETRY_PATTERNS.some(p => req.url.includes(p));
            const isRetryable = !skipRetry && (
              error.status === 0
              || (error.status >= 500 && error.status < 600)
              || (error as any).name === 'TimeoutError'
            );
            if (isRetryable) {
              const delay = 1500 * (index + 1);
              return timer(delay);
            }
            return throwError(() => error);
          })
        )
      ),
      catchError((error: HttpErrorResponse) => {
        // Auto-redirect para login em 401
        if (error.status === 401 && !this._isRedirecting) {
          this._isRedirecting = true;
          try {
            const router = this.injector.get(Router);
            // Limpa sessao basica
            localStorage.removeItem('user');
            localStorage.removeItem('selectedAccountId');
            router.navigate(['/login']).then(() => {
              this._isRedirecting = false;
            });
          } catch (e) {
            this._isRedirecting = false;
          }
        }
        return throwError(() => error);
      })
    );
  }
}
